<template>
    <div>
        <basic-container class="cards">
            <el-form :inline="true" :model="formInline" size="small" class="demo-form-inline">
                <el-form-item label="时间">
                    <el-date-picker class="w-150" :picker-options="startTime" @change="changeData" v-model="formInline.startDate" placeholder="开始日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="-" width="300px">
                    <el-date-picker class="w-150" :picker-options="endtTime" @change="changeData" v-model="formInline.endDate" placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属区域" prop="name">
                    <el-select @change="getBuildList" v-model="formInline.subPartId" size="small" clearable filterable @clear="clearPart" placeholder="请选择区域">
                        <template v-for="(item, index) in partList">
                            <el-option v-if="item.parent_id != 0" :key="index" :label="item.name" :value="item.id">
                            </el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="楼宇">
                    <el-select class="w-200" v-model="formInline.buildingId" clearable filterable size="small" @change="forceUpdate" placeholder="请选择所属楼宇">
                        <el-option v-for="(item, index) in buildList" :key="index" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button class="pull-right" type="primary" plain @click="exportTable" icon="el-icon-download" size="small">导出</el-button>
                </el-form-item>

                <el-form-item class="pull-right" label="历史" prop="history" width="150px">
                    <el-select @change="changeHistory" v-model="historyBB" size="small" clearable filterable @clear="search" placeholder="请选择历史版本">
                        <template v-for="(item, index) in historyList">
                            <el-option :key="index" :label="item.store_date" :value="item.store_date">
                            </el-option>
                        </template>
                    </el-select>
                </el-form-item>
            </el-form>
        </basic-container>
        <basic-container isCard>
            <div class="fts-16 text-center mar-b-10">
                企业自持房屋、土地载体资产汇总表
            </div>
            <el-table :data="tableData" style="width: 100%" id="exportTable" border v-loading="isLoading" element-loading-text="加载中，请稍后..." index :height="height">
                <!-- <el-table-column header-align="center" :label="`企业自持房屋、土地载体资产汇总表`"> -->
                <el-table-column type="index" fixed header-align="center" width="50">
                </el-table-column>
                <el-table-column prop="dwmc" fixed align="left" header-align="center" label="单位名称" width="240">
                </el-table-column>

                <el-table-column prop="rentersName" fixed align="left" header-align="center" label="资产类别" width="150">
                    <template slot-scope="{ row }">
                        <span>{{ row.zc_type }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="zcmc" align="left" fixed header-align="center" label="资产名称" width="200">
                </el-table-column>
                <el-table-column prop="ssly" align="left" fixed header-align="center" label="所属楼宇" width="200">
                </el-table-column>

                <el-table-column prop="sskm" align="left" header-align="center" label="所属科目" width="100">
                </el-table-column>

                <el-table-column label="坐落位置" align="left" header-align="center" prop="zlwz" width="260">
                </el-table-column>
                <el-table-column label="账面余额(元)" align="right" header-align="left" prop="zmye" width="150">
                    <template slot-scope="{ row }">
                        {{ toqfw(row.zmye) }}
                    </template>
                </el-table-column>
                <el-table-column label="建筑面积(m²/亩)" align="right" header-align="center" prop="room_area_sum" width="150">
                    <template slot-scope="{ row }">
                        {{ toqfw(row.room_area_sum) }}
                    </template>
                </el-table-column>
                <el-table-column label="实际使用面积(m²/亩)" align="right" header-align="center" prop="">
                    <el-table-column label="自用面积" align="right" header-align="center" prop="room_area_zy" width="150">
                        <template slot-scope="{ row }">
                            {{ toqfw(row.room_area_zy) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="未出租(闲置资产)面积" align="right" header-align="center" prop="room_area_wz" width="150">
                        <template slot-scope="{ row }">
                            {{ toqfw(row.room_area_wz) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="已出租面积" align="right" header-align="center" prop="room_area_yz" width="150">
                        <template slot-scope="{ row }">
                            {{ toqfw(row.room_area_yz) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="其他面积(已售面积)" align="right" header-align="center" prop="room_area_ys" width="150">
                        <template slot-scope="{ row }">
                            {{ toqfw(row.room_area_ys) }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="闲置资产金额(元)" align="right" header-align="center" prop="" width="100">
                </el-table-column>
                <el-table-column label="闲置资产面积占实际使用面积比率" align="right" header-align="center" prop="" width="100">
                </el-table-column>
                <el-table-column label="应收房租(元)" align="right" header-align="center" prop="ys_fz_sum" width="150">
                    <template slot-scope="{ row }">
                        {{ toqfw(row.ys_fz_sum) }}
                    </template>
                </el-table-column>
                <el-table-column label="已收房租(元)" align="right" header-align="center" prop="yj_fz_sum" width="150">
                    <template slot-scope="{ row }">
                        {{ toqfw(row.yj_fz_sum) }}
                    </template>
                </el-table-column>
                <el-table-column label="未收房租(元)" align="left" header-align="center" prop="" width="">
                    <el-table-column label="疫情减免" align="center" header-align="center" prop="yqjm" width="150">
                        <template slot-scope="{ row }">

                        </template>
                    </el-table-column>
                    <el-table-column label="政策性未收(元)" align="right" header-align="center" prop="ye_zc_fz_sum" width="150">
                        <template slot-scope="{ row }">
                            {{ toqfw(row.ye_zc_fz_sum) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="拖欠(元)" align="right" header-align="center" prop="ye_qy_fz_sum" width="150">
                        <template slot-scope="{ row }">
                            {{ toqfw(row.ye_qy_fz_sum) }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="bz" width="150" label="备注">
                </el-table-column>
                <!-- </el-table-column> -->
            </el-table>
        </basic-container>
    </div>
</template>

<script>
import { getMetaCommonList } from '@/api/busiMode/metaCommon';
import XLSXS from 'xlsx-style';
import FileSaver from 'file-saver';
import dayjs from 'dayjs';
import api from '@/api/reportForms/index';
import { getBuildingReceipt } from '@/api/reportForms/reportForms';
import numCard from '../../data-view/widgets/num-card';
const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
export default {
    data() {
        return {
            formInline: {
                startDate: '2024-01-01',
                endDate: '',
            },
            height: viewPortHeight - 320,
            value1: '',
            partList: [],
            value2: '',
            tableData: [],
            buildList: [],
            companyList: [],
            contractList: [],
            tdList: [],
            historyList: [],
            historyBB: '',
            partName: '',
            token: '',
            isLoading: false,
            startTime: {
                disabledDate: time => {
                    if (this.formInline.endDate) {
                        return time.getTime() > dayjs(this.formInline.endDate);
                    }
                },
            },
            endtTime: {
                disabledDate: time => {
                    if (this.formInline.startDate) {
                        //return dayjs(this.formInline.startDate).format('YYYY-MM-DD');
                        return time.getTime() < dayjs(this.formInline.startDate);
                    }
                },
            },
        };
    },
    mounted() {
        this.getPart();
        this.getHistory();
        this.formInline.endDate = dayjs().format('YYYY-MM-DD');
        this.search();
    },
    methods: {
        toqfw(num) {
            if (Number(num)) {
                let n = num;
                n = this.addDou(Number(num).toFixed(2));
                return n;
            } else {
                return num;
            }
        },
        addDou(value) {
            var isNegative = value < 0;
            value = Math.abs(value).toString();
            var decimalIndex = value.indexOf('.');
            if (decimalIndex === -1) {
                decimalIndex = value.length;
            }
            for (var i = decimalIndex - 3; i > 0; i -= 3) {
                value = value.slice(0, i) + ',' + value.slice(i);
            }
            if (isNegative) {
                value = '-' + value;
            }
            return value;
        },
        formatDate(createTime) {
            let obj = '';
            if (createTime) {
                obj = dayjs(createTime).format('YYYY-MM-DD');
            }
            return obj;
        },
        changeData() {
            if (this.formInline.startDate) {
                this.formInline.startDate = this.formatDate(this.formInline.startDate);
            } else {
                this.formInline.startDate = '';
            }
            if (this.formInline.endDate) {
                this.formInline.endDate = this.formatDate(this.formInline.endDate);
            } else {
                this.formInline.endDate = '';
            }
        },
        search() {
            if (this.formInline['startDate']) {
                this.formInline['startDate'] = dayjs(this.formInline['startDate']).format('YYYY-MM-DD HH:mm:ss');
            }
            if (this.formInline['endDate']) {
                this.formInline['endDate'] = dayjs(this.formInline['endDate']).format('YYYY-MM-DD HH:mm:ss');
            }

            this.getStatFinanceCalculateArea(this.formInline);
        },

        getStatFinanceCalculateArea(data) {
            let o = {};
            o = JSON.parse(JSON.stringify(data));
            if (data) {
                if (this.formInline.startDate) {
                    this.formInline.startDate = dayjs(this.formInline.startDate).format('YYYY-MM-DD HH:mm:ss');
                } else {
                    this.formInline.startDate = '';
                }
                if (this.formInline.endDate) {
                    this.formInline.endDate = dayjs(this.formInline.endDate).format('YYYY-MM-DD HH:mm:ss');
                } else {
                    this.formInline.endDate = '';
                }
            }
            this.isLoading = true;
            getBuildingReceipt(o)
                .then(res => {
                    this.tableData = [];
                    this.tdList = [];

                    const data = res.data;
                    let tableData = data.data.resultDetail;
                    let totalArea = {
                        ssly: '合计',
                    };
                    for (let key in data.data.resultTotal) {
                        if (Number.isFinite(data.data.resultTotal[key])) {
                            totalArea[key] = data.data.resultTotal[key].toFixed(2);
                        } else {
                            totalArea[key] = data.data.resultTotal[key];
                        }
                    }
                    tableData.push(totalArea);
                    this.tableData = tableData;
                    this.tdList = data.data.month;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        changeHistory() {
            this.historyList.forEach(e => {
                if (e.store_date == this.historyBB && e.store_result) {
                    let res = JSON.parse(e.store_result);
                    this.tableData = [];
                    this.tdList = [];
                    const data = res.data;
                    let tableData = data.resultDetail;
                    let totalArea = {
                        ssly: '合计',
                    };
                    console.log(data.resultTotal);
                    for (let key in data.resultTotal) {
                        if (Number.isFinite(data.resultTotal[key])) {
                            totalArea[key] = data.resultTotal[key].toFixed(2);
                        } else {
                            totalArea[key] = data.resultTotal[key];
                        }
                    }
                    tableData.push(totalArea);
                    this.tableData = tableData;
                    this.tdList = data.month;
                    this.isLoading = false;
                }
            });
        },
        getPart() {
            let body = {
                current: 1,
                size: 10,
                orders: [{ field: 'sort', sort: 'ASC' }],
            };
            getMetaCommonList('wisdom_park.wp_part', body).then(res => {
                const data = res.data.data;
                this.partList = data.records;
                //this.formInline.subPartId = this.partList[0]["id"];
                this.getBuildList();
            });
        },
        getHistory() {
            let body = {
                current: 1,
                size: 100,
            };
            getMetaCommonList('wisdom_park.wp_store_statistics_info', body).then(res => {
                const data = res.data.data;
                this.historyList = data.records;
            });
        },

        forceUpdate() {
            this.$forceUpdate();
        },
        clearPart() {
            delete this.formInline.subPartId;
        },
        getBuildList() {
            this.formInline.buildingId = '';
            this.partList.forEach(e => {
                if (e.id == this.formInline.subPartId) {
                    this.partName = e.name;
                }
            });

            getMetaCommonList('wisdom_park.wp_building', {
                size: 100,
                current: 1,
                wheres: [{ field: 'sub_part_id', value: this.formInline.subPartId }],
            }).then(res => {
                const data = res.data.data;
                this.buildList = data.records;

                //this.formInline.buildingId = this.buildList[0]["id"];
                this.$forceUpdate();
                //
            });
        },
        getCompanyList() {
            getMetaCommonList('wisdom_park_statistics.v_wp_company_building_stat', {
                size: 100,
                current: 1,
                wheres: [{ field: 'building_id', value: this.formInline.buildingId }],
            }).then(res => {
                const data = res.data.data;
                this.companyList = data.records;
            });
        },
        getContractList() {
            getMetaCommonList('wisdom_park_statistics.v_company_contract_stat', {
                size: 100,
                current: 1,
                wheres: [{ field: 'company_id', value: this.formInline.companyId }],
            }).then(res => {
                const data = res.data.data;
                this.contractList = data.records;
            });
        },

        // 点击事件触发的方法
        exportTable() {
            // 首先加载  <table id='excelTable'> 标签 为 workbook对象
            //let workbook = this.$XLSX.utils.table_to_book(document.getElementById('exportTable'), { raw: true });

            // var fix = document.querySelector('.el-table__fixed');
            // var workbook;
            // // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
            // if (fix) {
            //     /* 从表生成工作簿对象 */
            //     workbook = this.$XLSX.utils.table_to_book(document.querySelector('#exportTable').removeChild(fix));
            //     document.querySelector('#exportTable').appendChild(fix);
            // } else {
            //     workbook = this.$XLSX.utils.table_to_book(document.querySelector('#exportTable'));
            // }

            var workbook;
            var fix = document.querySelector('.el-table__fixed');
            var dt = document.querySelector('#exportTable');
            var xlsxParam = { raw: true }; //转换成excel时，使用原始的格式,解决工单号过长导致数字自动转换为科学计数法导致精度缺失
            if (fix) {
                workbook = this.$XLSX.utils.table_to_book(dt.removeChild(fix), xlsxParam);
                dt.appendChild(fix);
            } else {
                workbook = this.$xlsx.utils.table_to_book(dt, xlsxParam);
            }
            // 先定义列宽 ， 我这里文件一共有7 列 ，所以设置7列宽度相等都为 20 ，如果你有很多列建议直接 map()
            let wscols = [
                { wch: 5 },
                { wch: 22 },
                { wch: 22 },
                { wch: 22 },
                { wch: 20 },
                { wch: 15 },
                { wch: 15 },
                { wch: 20 },
            ];

            // 获取 需要设置样式的 sheet ，我这里只有 一个 sheet 所以索引默认加载了第一个
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            // 设置列宽
            sheet['!cols'] = wscols;
            // 定义框线样式
            const borderAll = {
                color: { auto: 1 },
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' },
            };

            // 这里的意思为 先默认代表表格的 7 个列  的 列号
            // 比如 A2 意思是 第一列 第2行
            const _letterList = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

            // 定义一个 箭头函数，接受三个参数，分别为 当前Sheet , 行列号（例如：‘A2’）, 是否是新增样式
            const _mapCellStyle = (_sheet, _key, _type) => {
                const _cellStyle = {
                    border: borderAll,
                    alignment: {
                        wrapText: true,
                        horizontal: 'center',
                        vertical: 'center',
                    },
                    font: {
                        name: '微软雅黑',
                        sz: 10,
                        height: 50,
                    },
                    height: 50,
                    bold: true,
                    numFmt: '0',
                };
                const _title = {
                    // border: borderAll,
                    alignment: {
                        wrapText: true,
                        horizontal: 'center',
                        vertical: 'center',
                    },
                    font: {
                        name: '微软雅黑',
                        sz: 16,
                    },
                    bold: false,
                    numFmt: '0',
                };
                if (_key == 'A1') {
                    if (_type === 'append') {
                        // 需要新增样式，说明当前加载的sheet中并不存在该单元格，可能当前单元格被前边合并，这种被合并的单元格也得设置样式，
                        // 否则就会出现 合并单元格只有第一格带框线，后边没框线的情况出现，所以这里需要将后边的边框样式也加上。
                        _sheet[_key] = {
                            s: _title,
                        };
                    } else {
                        // 若不是新增样式 则代表sheet中已存在该表格直接修改其 s 属性即可使属性生效
                        if (typeof _sheet[_key] === 'object') {
                            _sheet[_key].s = _title;
                        }
                    }
                } else {
                    if (_type === 'append') {
                        // 需要新增样式，说明当前加载的sheet中并不存在该单元格，可能当前单元格被前边合并，这种被合并的单元格也得设置样式，
                        // 否则就会出现 合并单元格只有第一格带框线，后边没框线的情况出现，所以这里需要将后边的边框样式也加上。
                        _sheet[_key] = {
                            s: _cellStyle,
                            v: _sheet['v'] + '1',
                        };
                    } else {
                        // 若不是新增样式 则代表sheet中已存在该表格直接修改其 s 属性即可使属性生效
                        if (typeof _sheet[_key] === 'object') {
                            _sheet[_key].s = _cellStyle;
                        }
                    }
                }
            };

            // sheet 不懂得可以单独打印一下，它其实就是一个对象，键代表行列号（‘A2’），值为该单元格的值，样式等，
            // 我们需要做的就是修改其值中的样式
            Object.keys(sheet).forEach((i, _) => {
                // 无用属性直接过滤
                if (i !== '!ref' || i !== '!cols' || i !== '!merges' || i !== 'Am') {
                    // 首先设置遍历到的 当前 key
                    let _nowKey = i;
                    // 然后调用 _mapCellStyle  渲染当前单元格样式
                    _mapCellStyle(sheet, _nowKey);
                    // 我们这里先获取下一个行列号  例如当前_nowKey 是 A1  这里就是获取到 B1 ,及 当前行的 下一列数据
                    let _nextKey = _letterList[_letterList.indexOf(_nowKey[0]) + 1] + i.slice(1);

                    // 判断 B1 是否在 Sheet的key中,如果不存在，只可能是因为B1所在单元格已经被A1所合并，所以我们需要将B1也调用一下  _mapCellStyle
                    // 渲染 B1 的样式，不然就会出现 A1 B1 这两格是合并的状态，只有A1有框线，而B1 没有框线的情况。
                    // 这里用 while 就是 要把需要合并的单元格全部 渲染上样式，直到可能 B4 在 Sheet中 停止
                    while (_nowKey[0] !== 'G' && !Object.keys(sheet).includes(_nextKey)) {
                        _mapCellStyle(sheet, _nextKey, 'append');
                        // 这里就是简单的交换索引
                        _nowKey = _nextKey;
                        _nextKey = _letterList[_letterList.indexOf(_nowKey[0]) + 1] + _nowKey.slice(1);
                    }
                }
            });

            let wopts = {
                bookType: 'xlsx',
                bookSST: false,
                type: 'buffer',
            };
            let _blob = XLSXS.write(workbook, wopts);
            let _title = '企业自持房屋、土地载体资产汇总表' + new Date().getTime() + '.xlsx';
            if (this.formInline.startDate) {
                let _title = this.formInline.startDate + '至' + this.formInline.endDate + _title;
            }

            FileSaver.saveAs(
                new Blob([_blob], {
                    type: 'application/octet-stream',
                }),
                _title,
            );
        },
        //传入 YYYY-MM , YYYY-MM  (2020-09)  (2020-12)  返回 YYYY-MM 数组
        getYearAndMonth(start, end) {
            let result = [];
            let starts = start.split('-');
            let ends = end.split('-');
            let staYear = parseInt(starts[0]);
            let staMon = parseInt(starts[1]) - 1;
            let endYear = parseInt(ends[0]);
            let endMon = parseInt(ends[1]);
            while (staYear <= endYear) {
                if (staYear === endYear) {
                    while (staMon < endMon) {
                        staMon++;
                        var str = staYear + '-' + (staMon >= 10 ? staMon : '0' + staMon);
                        result.push(str);
                    }
                    staYear++;
                } else {
                    staMon++;
                    if (staMon > 12) {
                        staMon = 1;
                        staYear++;
                    }
                    let str = staYear + '-' + (staMon >= 10 ? staMon : '0' + staMon);
                    result.push(str);
                }
            }
            return result;
        },
    },
};
</script>
<style scoped lang="scss" rel="stylesheet/scss">
.ft500 {
    font-weight: 700;
}
/deep/ .el-table thead.is-group th {
    background: #fafafa !important;
}
.bg-white {
    background-color: #fff !important;
}
.cards {
    background: #fff;
    padding: 15px 10px 0px 10px !important;
    padding-right: 0px !important;
    margin-bottom: 15px;
}
</style>
